import { render, staticRenderFns } from "./feature_fin.vue?vue&type=template&id=5b387f8d&"
var script = {}
import style0 from "./feature_fin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports